export interface DispatchTrip {
  id?: string;
  dateCreatedUtc?: Date;
  referenceNumber: string;
  startDate?: Date;
  bolNumber?: string;

  // Client / Bill To
  clientId?: string;
  clientName?: string;
  billToId?: string;
  billToName?: string;

  // Locations
  loadLocationId?: string;
  loadLocationName?: string;
  unloadLocationId?: string;
  unloadLocationName?: string;

  // Delivery Window
  deliveryWindowStartDate?: Date;
  deliveryWindowEndDate?: Date;

  // Driver
  driverId?: string;
  driverName?: string;
  driverNo?: string;

  // Product
  productId?: string;
  productName?: string;

  // Status
  status: DispatchTripStatus;
  statusDisplay?: string;

  // Dispatcher
  dispatcherId?: string;
  dispatcherName?: string;

  // Notes
  driverNotes?: string;
  clientNotes?: string;

  // Tractor/Trailer
  tractorId?: string;
  tractorNumber?: string;
  trailerId?: string;
  trailerNumber?: string;

  // Related collections
  notes?: DispatchTripNote[];
  files?: DispatchTripFile[];

  // Email tracking
  clientEmailSentUtc?: Date;
  driverEmailSentUtc?: Date;
}

export enum DispatchTripStatus {
  Requested = 0,
  Pending = 1,
  InTransit = 2,
  Delivered = 3,
}

export const DispatchTripStatusLabels: { [key: number]: string } = {
  [DispatchTripStatus.Requested]: "Requested",
  [DispatchTripStatus.Pending]: "Pending",
  [DispatchTripStatus.InTransit]: "In Transit",
  [DispatchTripStatus.Delivered]: "Delivered",
};

export interface DispatchTripNote {
  id?: string;
  dispatchTripId?: string;
  status?: string;
  type?: string;
  note?: string;
  dateCreatedUtc?: Date;
  createdByUserId?: string;
  createdByUserName?: string;
}

export interface DispatchTripFile {
  id?: string;
  dispatchTripId?: string;
  fileName?: string;
  originalFileName?: string;
  contentType?: string;
  blobName?: string;
  dateCreatedUtc?: Date;
  uploadedByUserId?: string;
  uploadedByUserName?: string;
}

export interface DispatchTripGridItem {
  id: string;
  referenceNumber: string;
  startDate?: Date;
  clientName?: string;
  billToName?: string;
  bolNumber?: string;
  loadLocationName?: string;
  unloadLocationName?: string;
  deliveryWindow?: string;
  productName?: string;
  driverId?: string;
  driverName?: string;
  driverEmail?: string;
  statusDisplay: string;
  dispatcherName?: string;
}

export interface DispatchTripFilter {
  dispatcherId?: string;
  billToId?: string;
  driverId?: string;
  status?: DispatchTripStatus;
  startDateFrom?: Date;
  startDateTo?: Date;
}

export interface DispatcherUser {
  id: string;
  name: string;
  email?: string;
}

export interface DriverTripCount {
  driverId: string;
  date: Date;
  count: number;
  trips: {
    id: string;
    referenceNumber: string;
    status: DispatchTripStatus;
  }[];
}
